import React, { useContext, useRef } from "react";
import { Dialog, Button, ButtonType, MessageBox, MessageBoxStatus } from "@yy/tofu-ui-react";
import { useHistory } from "react-router-dom";
import { ModalRoutes } from "./ModalSwitch";
import fetcher, { paths } from "../../lib/fetcher";
import { RegGuildResult } from "../../models/RegGuildResult";
import { HttpServiceMsg, HTTPService } from "../../lib/util";
import { showBeNormalGuildSuccessDialog } from "../Dialogs";
import { ChannelIdContext } from "../ChannelIdContextWrap";
import { stat } from "../../lib/hooks/useHiidoPV";
import { SettleSwitchContext, UserInfoContext } from "../../App";

const ChooseGuildTypeModal = () => {
  const history = useHistory();
  const a = useContext(ChannelIdContext);
  const userInfo = useContext(UserInfoContext);
  const isBaiduUser = userInfo && userInfo.isBaidu === "1";
  const isSettleSwitchOn = useContext(SettleSwitchContext);
  const shouldLimitBaiduUserAccess = isBaiduUser && isSettleSwitchOn;
  const clickFlag = useRef(false);

  const beStarGuild = () => {
    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "205" });

    history.replace(ModalRoutes.BeStarGuildProcess);
  };

  const beNormalGuild = async () => {
    if (clickFlag.current) return;
    clickFlag.current = true;

    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "204" });

    const { code, msg } = (await fetcher.post(
      `${paths.regGuild}?channelId=${a || "0"}` // web 端自然流量为「0」
    )) as RegGuildResult;
    // 关闭弹窗
    history.replace(ModalRoutes.Root);

    clickFlag.current = false;
    if (code === HTTPService.Ok) {
      showBeNormalGuildSuccessDialog();
    } else if (code === 104) { // SDK 账号
      MessageBox({
        title: "成为公会失败",
        status: MessageBoxStatus.FAIL,
        desc: '为YY百战直播公会身份，不能成为公会',
        showOk: false,
        cancelTxt: "确定",
      });
    } else if (code === 105) {
      MessageBox({
        title: "成为公会失败",
        status: MessageBoxStatus.FAIL,
        desc: '您未签署《公会服务协议》，不能直接成为公会',
        showOk: false,
        cancelTxt: "确定",
      })
      return;
    } else {
      // NOTE: 此接口后端没有返回 msg
      MessageBox({
        title: "成为公会失败",
        status: MessageBoxStatus.FAIL,
        desc: msg || HttpServiceMsg.ServiceError,
        showOk: false,
        cancelTxt: "确定",
      });
    }
  };

  return (
    <Dialog
      wrapperStyle={{ width: 562 }}
      active
      showCancelBtn={false}
      showConfirmBtn={false}
      onCancel={() => history.replace(ModalRoutes.Root)}
    >
      <div className="beguild-messagebox">
        <h3>成为公会</h3>
        <p className="beguild-hint">
          您当前申请的是普通公会，将无法享受以下星级公会专享权益，建议您升级为星级公会。
        </p>
        <div className="beguild-content">
          <div className="beguild-pre">
            <p>星级公会专享权益：</p>
            <ul>
              <li>最高30%的收益分成</li>
              <li>新晋星级公会扶持资源包（手Y热门、精彩世界、短号等）</li>
              <li>获得未绑定主播名单和快速邀请通道</li>
              <li>
                新晋星级公会资源扶持
                <a
                  className="tf-ui-link"
                  href="//www.yy.com/xn/165"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  详情 &gt;
                </a>
              </li>
            </ul>
          </div>
          <div className="begulid-hint">
            <p>温馨提示：成为公会后，将不能成为主播。</p>
          </div>
          <div className="beguild-btns">
            <Button
              type={ButtonType.Emphasis}
              className="with-tag-btn"
              style={{ width: 140 }}
              onClick={beStarGuild}
              disabled={shouldLimitBaiduUserAccess}
            >
              <span className="beguild-rec-tag">推荐</span>
              <span>成为星级公会</span>
            </Button>
            <Button style={{ width: 140 }} onClick={beNormalGuild}>
              成为普通公会
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ChooseGuildTypeModal;
